"use client";
import * as React from "react";
const SvgSpeedSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m14.72 4.2-1 1.51a6.6 6.6 0 0 1-.17 6.17H2.45a6.6 6.6 0 0 1 .9-7.71 6.4 6.4 0 0 1 3.53-1.94 6.3 6.3 0 0 1 3.99.58l1.49-1A8 8 0 0 0 7.02.56a8 8 0 0 0-4.88 2.52A8.2 8.2 0 0 0 0 8.18a8.2 8.2 0 0 0 1.6 5.32h12.8A8 8 0 0 0 16 8.9a8 8 0 0 0-1.3-4.7z" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.87 9.77a1.6 1.6 0 0 0 1.14.48 1.6 1.6 0 0 0 1.13-.48l4.53-6.9-6.8 4.6a1.6 1.6 0 0 0-.47 1.15 1.7 1.7 0 0 0 .47 1.15" }));
export {
  SvgSpeedSharp as default
};
